import { useEffect } from 'react';

import { JobSearch } from '@/components/jobs/job-search';
import { recordVisit } from '@/hooks/useVisitHistory';

export const meta = {
  label: 'Jobs Worker Traces',
  order: 12,
  section: 'Jobs',
};

export const JobWorkerTracesPage = () => {
  useEffect(() => {
    recordVisit('/job-worker-traces', 'Jobs Worker Traces', 'job');
  }, []);

  return (
    <div>
      <h2 className='font-mediumbold mb-4 text-xl text-neutral-900'>Jobs Worker Traces</h2>
      <JobSearch />
    </div>
  );
};
